class ScanAction {
	// WHEN SCAN AND FOUNDED THAT IT IS CREDIT CARD
	constructor(code = ""){
		this.code = code;
		// console.log('ScanAction Class Loaded : '+this.code);
	}

	/**
	 * do
	 * ฟังก์ชั่นเอาไว้จัดการ action ที่ส่งมาจาก MagicEye
	 * @param {*} data 
	 */
	do(data){
		switch(data.type){
			case "booking":
				this.booking(data.return);
				break;
			case "guest":
			case "member":
				this.customer(data.return);
				this.member(data.return, data.response);
				break;
			case "onsen_rfid":
				this.onsen_rfid(data.return);
				break;
			case "therapist":
				this.therapist(data.return);
				break;
			case "onsen_keychain":
				this.onsen_keychain(data.return);
				break;
			case "voucher":
			case "encrypt_voucher":
				this.voucher(data.return);
				break;
			case "collect":
				this.collect(data.return);
				break;
			case "swgprompt_qr":
				this.swgprompt_qr(data.return);
				break;
		}
	}

	/**
	 * creditCard
	 * เมื่อรูดด้วยเครื่องรูดบัตร (ที่เค้าไม่ได้ใช้กันแล้ว)
	 * @param {*} data 
	 */
	creditCard(data){
		$('#special-payment').append(data.show);
		setEDC();
		setLiveCal();
		doCloseBox();
	}

	/**
	 * guide
	 * จะทำงานตอนที่สแกน Guide QR Code
	 * @param {*} scanType 
	 */
	guide(scanType){
		// GUIDE QR
		// SCANZONE GUIDE SPA
		scanZoneInside(this.code, 'scan_command=guide&message=scan+guide+qrcode&type='+scanType);
		guideRequireSalesperson();
	}

	/**
	 * foc
	 * หากเป็นบัตร foc ก็จะเข้า action นี้
	 * @param {*} inject 
	 */
	foc(inject){
		var use_service_charge;

		// HIDE PAYMENT
		$('#payment_type_select .sub_group .payment_amount_input').val("");
		$('#payment_type_select .sub_group').fadeOut(200);

		//do discount
		$('#payment_sum, #payment').hide();
		$('#payment_sum2').show();
		$('.discount_percent_input').val(inject.value.foc_percent);
		use_service_charge = parseInt(inject.value.service_charge);
		if(use_service_charge){
			$('input[name=cal_service_charge]').prop('checked', true);
		}else{
			$('input[name=cal_service_charge]').prop('checked', false);
		}
		newRealtimeCalculation();
	}

	// PRODUCT METHOD
	product(inject){
		var product_exist;
		var current_input;
		var sub_type;
		var quantity;
		var to_delete;
		var product_to_delete;
		var product_id;
		var set;
		var sub_to_delete;
		var voucher_code;

		// console.log('Scan.Product');
		// console.log(inject);
		// console.log('this code : '+this.code);

		// SHOW STAFF PRODUCT BOX
		if(inject.type == 'product'){
			if(inject.return.product_category_slug == "staff_product"){
				showStaffBox();
			}
		}

		if(inject.type == 'product' || inject.type == 'cashcard' || inject.type == 'voucher' || inject.type == 'encrypt_voucher'){
			product_exist = $('input[serial="'+this.code+'"]').length;
			// console.log('product_exist : '+product_exist);
			if(product_exist){
				// console.log('product_exist');
				//get input quantity
				current_input = $('input[serial="'+this.code+'"]');
				sub_type = current_input.attr('sub_type');
				if(sub_type != "card"){
					quantity = parseInt(current_input.val()) + 1;

					current_input.val(quantity);
					// console.log('line : 80');
					realtimeCalculation(reApplyVoucher);
				}
			}else{
				$.ajax({
					type	:	"POST",
					dataType:	"json",
					data	:	{command: "scanProduct", index_id: current_product, code: this.code},
					url		:	"ajax.php",
					success	:	function(data){
						console.log("scanProduct");
						// console.log(data);
						if(data.type == 'skip'){
							// DO NOTHING
						}else if(data.type == "error" || data.type == "warning"){
							//alert('code error');
							$('#scan-product-message').html(data.show);
							
							// USE VOUCHER
							if(data.voucher_type != 'voucher_product_cannot_use'){
								getVoucher(data.Voucher.voucher_code);
							}
						}else{
							// check exist product
							if(data.type == "voucher"){
								$('.voucherzone').show();
								$('.voucherzone .zone').html(data.show);
								parent = $('.voucherzone');
								parent.find('.button.voucher-product-remove').click(function(){
									product_to_delete = $(this).parent().parent().parent();
									product_id = product_to_delete.attr('product_id');
									set = product_to_delete.attr('set');
									if(confirm(confirm_delete)){
										product_to_delete.remove();
										// DELETE VOUCHER FROM SESSION
										$.ajax({
											type	:	"POST",
											data	:	{command: "deleteVoucherProduct", product_id: product_id, set: set},
											url		:	"ajax.php",
											success	:	function(data){
												// console.log(data);
												// getVoucherInput();
												realtimeCalculation(reApplyVoucher);
											}
										});
									}
								});
								parent.find('.button.voucher-remove').click(function(){
									sub_to_delete = $(this).parent().parent();
									voucher_code = sub_to_delete.find('.code').val();
									if(confirm(confirm_delete)){
										sub_to_delete.remove();
										// DELETE VOUCHER FROM SESSION
										$.ajax({
											type	:	"POST",
											data	:	{command: "deleteSaleVoucher", code: voucher_code},
											url		:	"ajax.php",
											success	:	function(data){
												// console.log(data);
												// getVoucherInput();
												realtimeCalculation(reApplyVoucher);
											}
										});
									}
								});
								// PROMOTION BUTTON VOUCHER
								$('.button-product-promotion-price').click(function(){
									quantity = 1;
									$(this).parent().parent().parent().parent().find('.sub_discount').val($(this).val() * quantity).prop('readonly', true);
									realtimeCalculation();
								});
								$('.delete').click(function(){
									$(this).parent().parent().parent().parent().find('.sub_discount').prop('readonly', false).val('');
									realtimeCalculation();
								});
								
								parent.find('.live_cal').change(function(){
									realtimeCalculation();
								});
								realtimeCalculation(reApplyVoucher);
							}else if(data.type != "quantity"){
								$('.dropzone').append(data.show);
								setNumberOnly();
								parent = $('.product_group'+current_product);
								parent.find('.button.remove').click(function(){
									to_delete = $(this).parent().parent().parent();
									if(confirm(confirm_delete)){
										to_delete.remove();
										realtimeCalculation();
									}
								});

								// PROMOTION BUTTON
								$('.button-product-promotion-price').click(function(){
									parent.find('.sub_discount').val($(this).val() * quantity).prop('readonly', true);
									realtimeCalculation();
								});
								
								parent.find('.live_cal').change(function(){
									realtimeCalculation();
								});
								current_product++;
								// console.log('line : 181');
								realtimeCalculation(reApplyVoucher);
							}
						}
					}
				});
			}
		}else if(inject.type == 'guide'){
			this.guide('product');
		}
	}

	// SERVICE METHOD
	service(inject){
		var pin_exist;
		var button;
		var pin;
		var card_no;
		var ScanAction;

		ScanAction = this;

		if(inject.type == 'cashcard'){
			// DISABLED all Discount Inputs
			$('.discount_input, .new_price_input').val("").attr('disabled', 'disabled');
			newRealtimeCalculation();

			$('#scanbox-card').append(inject.show);
			pin_exist = $('input[name=pin]').length;
			doCardBoxClose();
			if(inject.is_null){
				var old_box;
				old_box = $('div[card_no='+inject.card_no+']');
				old_box.remove();

				// NO PIN
				$.ajax({
					type	:	"post",
					data	:	{command: "loadCashCard", code: code},
					dataType:	"json",
					url		:	"ajax.php",
					success	:	function(dataPIN){
						closeAllDiscountRelateInput();
						$('#scanbox-card').append(dataPIN.show);
						setCardInput();
						doCardBoxClose();

						// CASHIER PAGE
						// ฟังก์ชั่นใหม่
						getOrderList('cashcard');
					}
				});
			}else if(pin_exist){
				unlockGuide();
				unlockDiscount();

				// SET SUBMIT PIN
				$('button.submit-pin').click(function(){
					button = $(this);
					pin = $(this).parent().find('input[name=pin]').val();
					card_no = $(this).parent().find('input[name=pin]').attr('card_no');
					if(pin != ""){
						$.ajax({
							type	:	"post",
							data	:	{command: "submitPin", card_no: card_no, pin: pin, code: code},
							dataType:	"json",
							url		:	"ajax.php",
							success	:	function(dataPIN){
								if(dataPIN.pass){
									closeAllDiscountRelateInput();
									button.parent().parent().parent().fadeOut(200, function(){
										$(this).remove();
										$('#scanbox-card').append(dataPIN.show);
										setCardInput();
										doCardBoxClose();

										// CASHIER PAGE
										// ฟังก์ชั่นใหม่
										getOrderList('cashcard');

										// FOC
										if(dataPIN.value.foc){
											ScanAction.foc(dataPIN);
										}
									});
								}else{
									alert(dataPIN.text);
								}
							}
						});
					}
				});
			}
		}else if(inject.type == 'voucher' || inject.type == 'encrypt_voucher'){
			getVoucher(code);
		}else if(inject.type == 'guide'){
			this.guide('spa');
		}
	}

	booking(data){
		$("#magicEye").attr("class", "fas fa-certificate fa-spin");
		getConfirm('', 'Booking No. '+data.booking_no, 'View Detail'); // REMOVE RETURN ELEMENT
		$('#modal .cancel').click(function(){
			$("#magicEye").attr("class", "fas fa-bullseye");
		});
		$('#modal .confirm').click(function(){
			window.open('?p=booking&s=info&code='+data.booking_no, '_booking_info'); // REMOVE RETURN ELEMENT
		});
	}

	therapist(data){
		if(data.status == 'active'){
			// AJAX CHECK-IN
			$.ajax({
				type	:	"post",
				data	:	{command: "checkInTherapist", id: data.id, employee_code: data.employee_id, type: data.type},
				dataType:	"json",
				async	:	false, 
				url		:	"ajax.php",
				success	:	function(data){
					if(data.type == 'out'){
						getConfirm('', '<i class="fas fa-home"></i> เช็คเอ้าท์หมอ <span class="wmci">'+data.employee_id+' '+data.firstname+'</span> แล้ว', 'View Therapist Time');
					}else if(data.type == 'log'){	
						getConfirm('', 'บันทึกการสแกนของหมอ <span class="wmci">'+data.employee_id+' '+data.firstname+'</span> แล้ว', 'hide');
					}else{
						getConfirm('', 'เช็คอินหมอ <span class="wmci">'+data.employee_id+' '+data.firstname+'</span> แล้ว', 'View Therapist Time');
					}
					
					$('#modal .confirm').click(function(){
						window.open('?p=admin&s=time', '_therapist_time'); // REMOVE RETURN ELEMENT
					});
				}
			});
		}else{
			alertme('หมอ '+data.employee_id+' '+data.firstname+' สถานะไม่ active');
		}
	}

	customer(data){
		var readonly;
		
		if(this.editable === true){
			readonly = false;
		}else{
			readonly = true;
		}
		$('#customer_telephone').val(data.telephone ? data.telephone : data.telephone_number).prop('readonly', readonly);
		$('#customer_email').val(data.email).prop('readonly', readonly);
		$('#customer_firstname').val(data.firstname ? data.firstname : data.first_name).prop('readonly', readonly);
		$('#customer_lastname').val(data.lastname ? data.lastname : data.last_name).prop('readonly', readonly);
	}

	// FOR WELLNESSME QR LOGIN
	member(data, response){
		var wmlogin_exist;
		var payment_type_exist;
		var order_id;
		var member_id;
		var wmqrcode;
		var page;
		var sub_page;
		var customer_dropzone_exist;

		// MEMBER WIDGET
		customer_dropzone_exist = $('.customer-dropzone').length;
		if(customer_dropzone_exist){
			if(response.pass){
				$('.customer-dropzone').html(response.show);
			}
		}

		wmlogin_exist = $('#wmlogin').length;
		if(wmlogin_exist){
			if(!data.is_join_loyalty_program){
				$('#wmlp-icon').attr('class', 'far fa-star-half fa-4x red');
				$('.point-expire-date').text(data.point.message);
			}else{
				$('[data-display="point-expire-date"]').text(data.point.point_expiration_date_display);
			}
			$('[name="wmqrcode"]').val(this.code);
			$('[data-display="point"]').text(data.point.active_point);
			
			$('[data-display="point-member_id"]').text(data.user_id);
			$('[data-display="point-member-name"]').text(data.fullname);
			$('#wmlogin').fadeOut(0).removeClass('hide').fadeIn(500);
			$('#inventory-login, #customer-basic-information').hide();
		}

		// ADD PAYMENT LOGIN
		payment_type_exist = $('#payment_type').length;
		if(payment_type_exist){
			order_id = $('input[name=order_id_array]').val();
			member_id = data.user_id;
			wmqrcode = this.code;
			if(member_id){
				$('#wellnessme-login-message').html('<div class="cl bold size-2 box"><i class="fas fa-spinner fa-spin wmci"></i> logging in</div>');
				if(order_id){
					// ADD PAYMENT PAGE
					$.ajax({
						type	:	"POST",
						data	:	{command: "bindMemberToOrder", order_id: order_id, member_id: member_id, wmqrcode: wmqrcode},
						dataType:	"json",
						url		:	"ajax.php",
						success	:	function(data){
							location.reload();
						}
					});
				}

				// PRODUCT PAGE
				// BIND MEMBER TO PAYMENT TYPE PRODUCT PAGE
				page = $('input[name=page]').val();
				sub_page = $('input[name=sub_page]').val();
				if(page == 'product' || page == 'onsen'){
					getMemberPaymentType(member_id, page, sub_page);
				}
			}
		}
	}

	onsen_rfid(data){
		var RFID_register_exit;
		var RFID_exist;

		RFID_register_exit = $('#registerRFID').length;
		RFID_exist = $('#scanRFID').length; // หน้า ONSEN
		if(RFID_register_exit || RFID_exist){
			doRFIDRegister(data.code);
			if(RFID_exist){
				loadRFID(data.code);
			}

			// AUTO FILL CUSTOMER INFO
			if(typeof data.customer_info != 'undefined' && data.customer_info.telephone != ''){
				$('#customer_telephone').val(data.customer_info.telephone);
				$('#customer_firstname').val(data.customer_info.firstname);
				$('#customer_lastname').val(data.customer_info.lastname);
				$('#customer_email').val(data.customer_info.email);
				checkCustomerInfoInput();
			}
		}
	}

	onsen_bag(data){
		loadRFID(data.code);
	}

	onsen_keychain(data){
		doKeychainRegister(data.keychain_code);
	}

	voucher(data){
		var command;
		command = $('input[name=command]').val();

		// CHECK VOUCHER ON SALE PAGE
		if(command == "checkorder"){
			if(data.voucher_id){
				$('#sale-page-encrypt-voucher-box').removeClass('hide');
				$('#voucher_encrypt_code').val(data.encrypt_voucher_code).prop("readonly", true);
			}
		}
	}

	collect(data){
		var collect_message;
		var input_collect_amount;
		var max_collect_amount;
		if((data.is_collectable == "true" || data.is_collectable == "1") && data.voucher_status == "ready" && data.collect_id == null){
			// COLLECT STATUS
			collect_message = "<span class=\"lightgreen\"><i class=\"fas fa-check\"></i> This voucher is collectable</span>";

			$('input[name=voucher_id]').val(data.voucher_id);
			$('button.collect').prop('disabled', false);

			// AMOUNT INPUT
			if(data.is_collect_amount_input == "true" || data.is_collect_amount_input == "1"){
				$("#collect_input_amount").removeClass("hide");
				$("#collect_input_amount input[name=collect_amount_input]").addClass("require").prop('disabled', false);
				$("#max_collect_amount").html(data.max_collect_amount);

				// CHECK AMOUNT
				$('input[name=collect_amount_input]').keyup(function(){
					input_collect_amount = Number($(this).val());
					max_collect_amount = Number($("#max_collect_amount").text());
					if(input_collect_amount > max_collect_amount){
						alert("Input exceeds the collectable amount");
						$('input[name=collect_amount_input]').val("");
					}
				});
			}
		}else if(data.collect_id > 0){
			collect_message = "<span class=\"red\"><i class=\"fas fa-times\"></i> Voucher is already redeemed, collect_id : "+data.collect_id+"</span>";
			$('button.collect').prop('disabled', true);
		}else{
			collect_message = "<span class=\"red\"><i class=\"fas fa-times\"></i> Can not redeem this voucher.</span>";
			$('button.collect').prop('disabled', true);
		}

		// DISPLAY
		$('#voucher').removeClass("hide");
		$('#collect-box .collect_message').remove();
		$('.dropzone #voucher .voucher_code .value').html(data.voucher_code);
		$('.dropzone #voucher .title .value').html(data.voucher_name);
		$('.dropzone #voucher .description .value').html(data.short_description);
		$('.dropzone #voucher .voucher_status .value').html(data.voucher_status);
		$('.dropzone .is_collectable').html(collect_message);
	}

	swgprompt_qr(data){
		$.ajax({
			url		:	"ajax.php",
			data	:	{command: "SWGPromptQrScan", code: data.qr.code},
			dataType:	"json",
			type	:	"POST",
			beforeSend	:	function(){
				loading();
			},
			success	:	function(data){
				unload();
				$('.dropzone').html(data.show);
			}
		});
	}
}
